import { AdblockDashboard } from '../../components/dashboards/adblock-bypass/AdblockDashboard';

export function AdblockBypassPage(): JSX.Element {
  return <AdblockDashboard />;
}